export default __webpack_public_path__ + "static/media/pantry1-afterI-1920w.7b56c715.png";